import offsetImg1 from "../../assets/img/op1.png";
import offsetImg2 from "../../assets/img/op2.png";
import offsetImg3 from "../../assets/img/op3.png";
import offsetImg4 from "../../assets/img/op4.png";
import offsetImg5 from "../../assets/img/op5.png";
import offsetImg6 from "../../assets/img/op6.png";

export const offsetLinks = [
    {
      title: "Heidelberg GTO Printing Machine",
      description: "Heidelberg GTO 52 Single Color Offset Printing Machine. Max Paper Size: 36 x 52cm; Print Speed: Max 8000 SPH; Dimensions: 1350 x 1400 x 1550mm (L x W x H).",
      imgUrl: offsetImg1,
    },
    {
      title: "Kord 64 Printing Machine",
      description: "Kord 64 Printing Machine can print enormous numbers of copies with unparalleled caliber, maintaining the color fidelity at the same time.",
      imgUrl: offsetImg2,
    },
    {
      title: "Gestetner 211 H Offset Printing Machine",
      description: "Gestetner 211 H Offset Printing Press Specifications: Max Paper Size. 264 x 365mm ; Speed Range: 5000 – 9000 MI.P.H ; Registration: Push side guides, vacuum pull side guides (optional).",
      imgUrl: offsetImg3,
    },
    {
      title: "Gestener 311 Offset Printing Machine",
      description: "Gestener 311 Offset Printing Machine: Prints colour separation, black and white,  A4 size, quoto size, A5 size, 4by5 business size in colour process and black and white print",
      imgUrl: offsetImg4,
    },
    {
      title: "4 Colour Offset Printing Machine",
      description: "Suitable for printing large and medium runs in a short time, with very good quality. Fewer wasted prints and contrast issues is guaranteed. As a result, you get flawless images on every piece.",
      imgUrl: offsetImg5,
    },
    {
      title: '"45" Polar 115 ED - Autotrim Paper Cutter',
      description: "With Factory computer, Gear Box Driven Knife, Hydraulic Clamping, Safety Eye Beams, Waste Removal Bin. Size 45inch; Sheet Width 45inch; Sheet Depth 45inch",
      imgUrl: offsetImg6,
    },
  ];